/* eslint-disable custom-eslint-rules/force-logicalOperandsMustBeBoolean */
import type { Properties as CSSProperties } from "csstype";
import { motion } from "framer-motion";
import styled from "styled-components";
import { ITheme } from "../Theme/Theme.types.js";
import { StyleModalProps } from "./Modal.types.js";

export const StyledModalOverlay = styled(motion.div)<{ overlayPointerEventsActivated: boolean }>`
    background: ${(props) => props.theme.colors.primary[10]};
    opacity: 0.7;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: ${({ theme }: { theme: ITheme }) => theme.elevationLevels.six};
    display: flex;
    pointer-events: ${({ overlayPointerEventsActivated }) => (overlayPointerEventsActivated ? "auto" : "none")};
`;

export const StyledModal = styled(motion.div)<StyleModalProps>`
    ${(props) => !props.fluid && "max-"}width: ${(props) => (props.width ? props.width : "90vw")};
    ${(props) => !props.fluid && "max-"}height: ${(props) => (props.height ? props.height : "90vh")};
    position: absolute;
    z-index: ${({ theme }: { theme: ITheme }) => theme.elevationLevels.six};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: ${(props) => props.theme.radius.l};
    box-shadow: ${({ theme }) => theme.shadows.popover};
    overflow: ${(props) => props.overflow};
    border: 3px solid ${(props) => props.theme.grayscale.white};
    background: ${(props) => (props.background ? props.background : props.theme.backgrounds.interface)};
`;

export const StyledModalBody = styled.div<{
    gap: keyof ITheme["spacing"];
}>`
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: ${(props) => `${props.theme.spacing[props.gap]}`};
`;

export const StyledHead = styled.div`
    padding: ${(props) => `${props.theme.spacing[32]} ${props.theme.spacing[32]} 0 ${props.theme.spacing[32]}`};
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: ${(props) => `${props.theme.spacing[16]}`};
`;

export const TitleContainer = styled.div`
    display: flex;
    flex: 1;
`;

export const StyledContent = styled.div<{
    fluidContent: boolean;
    standalone: boolean;
    overflowYStyle: CSSProperties["overflowY"];
    overflowXStyle: CSSProperties["overflowX"];
}>`
    padding: ${(props) =>
        props.fluidContent
            ? 0
            : `${props.standalone ? props.theme.spacing[32] : "0"} ${props.theme.spacing[32]} ${props.theme.spacing[32]} ${props.theme.spacing[32]}`};
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    min-height: 0;
    overflow-y: ${({ overflowYStyle }) => overflowYStyle};
    overflow-x: ${({ overflowXStyle }) => overflowXStyle};
`;
